import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["validate", "parse", "format", "disabled", "mobile"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Field } from 'react-final-form';
import { Jcb, Maestro, MasterCard, Mir, Visa } from "../icons";
import TextField from '../Textfield';

var getCardValidator = function getCardValidator(pattern) {
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return pattern.test(value.replace(/[^0-9]/gi, ''));
  };
};

export var cardsWithIcons = [{
  type: 'visa',
  icon: /*#__PURE__*/React.createElement(Visa, null),
  validate: getCardValidator(/^4[\d]{15}$/)
}, {
  type: 'mir',
  icon: /*#__PURE__*/React.createElement(Mir, null),
  validate: getCardValidator(/^220[0-4][\d]{12,15}$/)
}, {
  type: 'maestro',
  icon: /*#__PURE__*/React.createElement(Maestro, null),
  validate: getCardValidator(/^(50|(5[6-9])|60|63|67)[\d]{14,16}$/)
}, {
  type: 'mastercard',
  icon: /*#__PURE__*/React.createElement(MasterCard, null),
  validate: getCardValidator(/(^(5[1-5])[\d]{14}$)|(^(222[1-8][0-9]{2}|2229[0-8][0-9]|22299[0-9]|22[3-9][0-9]{3}|2[3-6][0-9]{4}|27[01][0-9]{3}|2720[0-8][0-9]|27209[0-9])[\d]{10,13}$)/)
}, {
  type: 'jcb',
  icon: /*#__PURE__*/React.createElement(Jcb, null),
  validate: getCardValidator(/^35(28|29|[3-8][0-9])[0-9]{12}$/)
}];
export var detectCardType = function detectCardType(cardNumber) {
  var card = cardsWithIcons.find(function (item) {
    return item.validate(cardNumber);
  });
  return card && card.type;
};
export var normalizeCVV = function normalizeCVV() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.replace(/[^0-9]/gi, '');
};
export var cardHolderPattern = /^[A-Z-'. ]{5,50}$/i;
export var requiredValidation = function requiredValidation() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (value) {
    return value ? undefined : text;
  };
};
/* --------------------- card number ---------------------  */

export var cardNumberValidation = function cardNumberValidation(_ref) {
  var requiredText = _ref.requiredText,
      _ref$cardNumberText = _ref.cardNumberText,
      cardNumberText = _ref$cardNumberText === void 0 ? true : _ref$cardNumberText;
  return function (value) {
    var required = requiredValidation(requiredText)(value);
    var cardNumber = cardsWithIcons.some(function (item) {
      return item.validate(value);
    }) ? undefined : cardNumberText;
    return required || cardNumber;
  };
};
export var formatCardNumberForMobile = function formatCardNumberForMobile() {
  var cardNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return cardNumber.split(' ').slice(2).join(' ');
};
/* --------------------- card holder ---------------------  */

export var cardHolderValidation = function cardHolderValidation(_ref2) {
  var requiredText = _ref2.requiredText,
      _ref2$cardHolderText = _ref2.cardHolderText,
      cardHolderText = _ref2$cardHolderText === void 0 ? true : _ref2$cardHolderText;
  return function (value) {
    var required = requiredValidation(requiredText)(value);
    var cardHolder = cardHolderPattern.test(value) ? undefined : cardHolderText;
    return required || cardHolder;
  };
};
export var cardExpirationValidation = function cardExpirationValidation(_ref3) {
  var requiredText = _ref3.requiredText,
      _ref3$cardExpirationT = _ref3.cardExpirationText,
      cardExpirationText = _ref3$cardExpirationT === void 0 ? true : _ref3$cardExpirationT;
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var required = requiredValidation(requiredText)(value);

    var _value$split = value.split('/'),
        _value$split2 = _slicedToArray(_value$split, 2),
        month = _value$split2[0],
        year = _value$split2[1];

    var isNaN = Number.isNaN;
    var currentTime = new Date().getTime();
    month = +month;
    year = +year;
    if (required) return required;
    if (month > 12 || month < 1 || isNaN(month) || isNaN(year) || new Date(year + 2000, month).getTime() < currentTime) return cardExpirationText;
    return undefined;
  };
};
/* --------------------- cvc ---------------------  */
// eslint-disable-next-line no-unused-vars

export var cvcValidation = function cvcValidation(_ref4) {
  var requiredText = _ref4.requiredText,
      isRequired = _ref4.isRequired;
  return function (value) {
    return isRequired ? requiredValidation(requiredText)(value) : undefined;
  };
};
export var getIconByType = function getIconByType() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var result = cardsWithIcons.find(function (item) {
    return item.type === type.toLowerCase();
  });
  return result && result.icon;
};
export var getMethodsById = function getMethodsById(methods) {
  return methods.reduce(function (acc, method) {
    if (!method.icon) {
      acc[method.id] = _objectSpread(_objectSpread({}, method), {}, {
        icon: getIconByType(method.type)
      });
    } else {
      acc[method.id] = method;
    }

    return acc;
  }, {});
};
export var initializeMethod = function initializeMethod(methods, selected) {
  var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var method = methods.find(function (option) {
    return option.id === selected && !disabled.includes(selected);
  });
  if (method) return method.id;
  method = methods.find(function (option) {
    return !disabled.includes(option.id);
  });
  if (method) return method.id;
  return null;
};
/* --------------------- transform cards --------------------- */

function isCorrectMask() {
  var cardNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var spaces = cardNumber.match(/\s/g);
  return !(!spaces || spaces && spaces.length !== 3);
}

export var transformCards = function transformCards(_ref5) {
  var disableAutoMaskChar = _ref5.disableAutoMaskChar;
  return function (card) {
    var _ref6 = card || {},
        _ref6$number = _ref6.number,
        number = _ref6$number === void 0 ? '' : _ref6$number;

    var isValidNumberLength = number.replace(/\s/g, '').length === 16;

    if (!isCorrectMask(number) && isValidNumberLength) {
      number = number.replace(/\s/g, '').replace(/(.{4})/g, '$1 ').trim();
    }

    return _objectSpread(_objectSpread({}, card), {}, {
      number: disableAutoMaskChar ? number : number.replace(/[^\d\s]/g, '*'),
      isValidNumberLength: isValidNumberLength
    });
  };
};
export var getTextField = function getTextField(name, _ref7) {
  var validate = _ref7.validate,
      parse = _ref7.parse,
      format = _ref7.format,
      disabled = _ref7.disabled,
      mobile = _ref7.mobile,
      props = _objectWithoutProperties(_ref7, _excluded);

  return /*#__PURE__*/React.createElement(Field, {
    name: name,
    validate: validate,
    parse: parse,
    format: format
  }, function (_ref8) {
    var input = _ref8.input,
        meta = _ref8.meta;
    return /*#__PURE__*/React.createElement(TextField, _extends({}, input, {
      invalid: meta.touched && meta.invalid,
      disabled: disabled,
      size: mobile ? undefined : 'small'
    }, props));
  });
};